<template>
<div class="login">
    <div class="container">
        <img src="https://edlservices.s3.eu-north-1.amazonaws.com/woodblocker/woodblocker-logo.svg" alt="woodblocker-logo" width="250px;"/>
        <b-card title="ΣΥΝΔΕΣΗ" sub-title="Σύνδεση στη σελίδα διαχείρισης">
            <b-card-text class="text-center pt-5">
                <b-form @submit.prevent="login">
                    <b-form-group >
                        <label>E-mail:</label>
                        <b-form-input type="text" v-model="email"></b-form-input>
                    </b-form-group>

                    <b-form-group>
                        <label>Password:</label>
                        <b-form-input type="password" v-model="password"></b-form-input>
                    </b-form-group>

                    <b-button variant="primary" type="submit">Σύνδεση</b-button>

                </b-form>
                <b-alert v-if="error" show variant="danger">{{error}}</b-alert>
            </b-card-text>
        </b-card>

    </div>
</div>
</template>
<style lang="scss">
    .login{
        margin-top:60px;
        label{
            width:200px;
        }
        .form-control{
            display:inline-block;
            max-width:200px!important;
        }
    }
</style>
<script>

    import axios from'axios'

    export default{

        data(){
            return{
                email: null,
                password: null,
                error: null
            }
        },

        methods:{
            login(){
                this.error = null;

                axios.post(this.apiUrl+'/users/login', {email: this.email, password: this.password}).then(result=>{
                    localStorage.setItem('token', result.data.token);
                    this.$router.push('/');
                }).catch( () =>{
                    this.error = "Αποτυχία σύνδεσης. Δοκιμάστε ξανά!";
                });
            }
        }
    }

</script>